import { Component, effect, HostBinding, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [TranslateModule],
  selector: 'kr-status',
  template: `
    @let title = i18nPrefix() + '.' + type() | translate;
    @if (small()) {
      <span [title]="title ? title.charAt(0).toUpperCase() : ''">
        {{ title ? title.charAt(0).toUpperCase() : '' }}
      </span>
    } @else {
      {{ title }}
    }
  `,
  styleUrls: ['./status.component.scss'],
})
export class StatusComponent {
  type = input<string>('');
  i18nPrefix = input<string>();
  small = input<boolean>(false);

  @HostBinding('class') hostClasses = '';

  hostClassesEffect = effect(() => {
    this.hostClasses = `kr-status kr-status_${this.type()} ${this.small() ? 'kr-status_small' : ''}`;
  });
}
